import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoupleCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDoupleCheck"><Path d="M19.3994 4.79395L7.78613 20.4189L0.59668 14.7969L1.82812 13.2217L7.40332 17.5801L17.7939 3.60059L19.3994 4.79395Z" fill="currentColor"/><Path d="M23.3994 4.79395L11.8008 20.3994L10.1953 19.2061L21.7939 3.60059L23.3994 4.79395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoupleCheck;
